import { openapi_website_cms_removeFilter, Response200Type, decodeResponse200 } from 'src/api_openapi/generated/openapi_website_cms_removeFilter';
import { MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType } from 'src_common/browser/apiUtils';
import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';

export type RemoveFilterType = Response200Type extends Array<infer Model> ? Model : never;

const decode = (status: number, data: ResponseType): Response200Type  => {
    if (status === 200 && data.type === 'json') {
        return decodeResponse200(data.json);
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export interface RemoveFilterParamsType {
    filterId: number
}

export const removeMarketFilter = {
    browser: {
        params: (params: RemoveFilterParamsType): ParamsFetchType<RemoveFilterParamsType> => {
            return {
                type: MethodType.DELETE,
                url: '/api-web/remove-filter',
                body: params
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.DELETE,
        urlBrowser: '/api-web/remove-filter',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<RemoveFilterParamsType>): Promise<GenerateUrlApiType> => {

        const resp = await openapi_website_cms_removeFilter(params.API_URL, params.API_TIMEOUT, params.jwtToken, {
            universe: params.API_UNIVERSE,
            id: params.req.body.filterId
        });

        return {
            passToBackend: false,
            status: resp.status,
            responseBody: resp.body
        };
    }
};
